import {
  CompositeFilterType,
  createEmptyCompositeGroups,
  ProductQueryMode,
} from '@/modules/core/compositeQuery';

export type CategoryDeepLinkPayload = {
  categoryId: number;
  queryMode: ProductQueryMode;
  enabledFilterTypes?: CompositeFilterType[];
};

const EMPTY_PRODUCTS_DATA = {
  pages: {},
  total: null,
  countKey: null,
  countStatus: 'idle',
  enterpriseSearch: true,
};

const EMPTY_INTEREST_TOGGLES = {
  marketers: false,
  manufacturers: false,
  brands: false,
  ingredients: false,
  flavours: false,
  fragrances: false,
  packaging_types: false,
  packaging_materials: false,
};

const DEFAULT_INTEREST_ACTIONS = {
  marketers: 'include',
  manufacturers: 'include',
  brands: 'include',
  ingredients: 'include',
  flavours: 'include',
  fragrances: 'include',
  packaging_types: 'include',
  packaging_materials: 'include',
};

export const applyCategoryDeepLinkState = (
  state: Record<string, any>,
  payload: CategoryDeepLinkPayload,
) => {
  const categoryId = Number(payload?.categoryId);
  if (!Number.isSafeInteger(categoryId) || categoryId <= 0) return state;

  const queryMode: ProductQueryMode = payload?.queryMode === 'composite' ? 'composite' : 'simple';
  const enabledFilterTypes = Array.isArray(payload?.enabledFilterTypes)
    ? payload.enabledFilterTypes.filter(
        (type): type is CompositeFilterType =>
          type === 'category_of_interest' || type === 'claim_of_interest',
      )
    : ['category_of_interest'];
  const categoryValue = {
    category_ids: [categoryId],
    mode: 'custom' as const,
  };
  const compositeGroups = createEmptyCompositeGroups();
  let compositeGroupSequence = 0;

  if (queryMode === 'composite') {
    compositeGroupSequence += 1;
    compositeGroups.category_of_interest = [
      {
        id: `category_of_interest-${compositeGroupSequence}`,
        value: categoryValue,
      },
    ];
    if (enabledFilterTypes.includes('claim_of_interest')) {
      compositeGroupSequence += 1;
      compositeGroups.claim_of_interest = [
        {
          id: `claim_of_interest-${compositeGroupSequence}`,
          value: undefined,
        },
      ];
    }
  }

  return {
    ...state,
    ingredientSearchInput: '',
    selectedIngredients: [],
    filters: {},
    interestToggles: { ...EMPTY_INTEREST_TOGGLES },
    interestActions: { ...DEFAULT_INTEREST_ACTIONS },
    interestSelections: {},
    moduleFilters: { category_of_interest: categoryValue },
    queryMode,
    compositeGroups,
    compositeGroupSequence,
    productsData: { ...EMPTY_PRODUCTS_DATA },
    selectedRows: [],
    ingredientSuggestions: [],
    currentPage: 1,
  };
};
